// src/calendarConfig.js
export const CLIENT_ID = '1037213212817-l4kjan0m9vke3m6ajk76mns2slesdnd3.apps.googleusercontent.com';
export const API_KEY = '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';
export const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly';
export const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';
